import { z } from 'zod';

/**
 * 2026 Enterprise Standard Timestamp Schema
 * 
 * A universal, highly resilient timestamp schema that:
 * 1. Accepts strings or Date objects
 * 2. Verifies they are valid dates
 * 3. Transforms them into strict ISO strings
 * 4. Guarantees normalized format for UI consumption
 */
export const TimestampSchema = z.union([z.string(), z.date()])
    .refine((val) => !isNaN(new Date(val).getTime()), {
        message: "Invalid date format",
    })
    .transform((val) => new Date(val).toISOString());

/**
 * Optional timestamp schema for fields that may be null or undefined
 */
export const OptionalTimestampSchema = TimestampSchema.optional().nullable();

/**
 * Base model schema with common fields for all database entities
 * Extend this schema for domain-specific models
 */
export const BaseModelSchema = z.object({
    id: z.string().uuid(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
